import { render, staticRenderFns } from "./ToastBox.vue?vue&type=template&id=5449edbc&scoped=true&lang=pug&"
import script from "./ToastBox.vue?vue&type=script&lang=js&"
export * from "./ToastBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449edbc",
  null
  
)

export default component.exports